var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.71941,
    cy: 4.85189,
    r: 3.18536,
    stroke: "#200E32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66676 12.4673C2.6659 12.2434 2.71598 12.0222 2.81321 11.8205C3.11832 11.2103 3.97873 10.8869 4.69269 10.7404C5.2076 10.6305 5.72962 10.5571 6.25486 10.5207C7.22731 10.4353 8.20537 10.4353 9.17782 10.5207C9.70302 10.5575 10.225 10.6309 10.74 10.7404C11.4539 10.8869 12.3144 11.1798 12.6195 11.8205C12.815 12.2317 12.815 12.7091 12.6195 13.1203C12.3144 13.761 11.4539 14.0539 10.74 14.1943C10.2257 14.3087 9.70348 14.3842 9.17782 14.42C8.38633 14.4871 7.59114 14.4994 6.79796 14.4566C6.61489 14.4566 6.43793 14.4566 6.25486 14.42C5.73117 14.3846 5.21096 14.3091 4.6988 14.1943C3.97873 14.0539 3.12442 13.761 2.81321 13.1203C2.71648 12.9162 2.66645 12.6931 2.66676 12.4673Z",
    stroke: "#200E32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.5c9d0fe8bcf39845a53393d3a427c6af.svg";
export { ForwardRef as ReactComponent };